export default {"src":"/_next/static/media/shareFbBlue.c478df26.svg","height":32,"width":32};